

import React from 'react'
import { Link } from "react-router-dom";
import Layout from '../../components/layout'
import ServiceBox from '../../components/servicebox'
import MotionDiv from '../../components/motion';
import ContactButton from '../../components/contactbutton'

import Video from '../../components/video'

import Terminal from '../../components/terminal'


export default function HomePage() {
  return (
    <div id="home">
      <div className="flex text-white flex-col min-h-screen relative">

        {/* Detta element ligger ovanpå videon */}
        <div className="absolute top-8 left-0 right-0 z-10 h-full">

          <div className="flex flex-col sm:flex-row h-full">
            <div className="flex flex-col items-center h-4/5 sm:h-full">
              <div className="sm:w-1/2 w-4/5 sm:h-2/3 h-full content-center" >
                <h1 className="text-4xl">
                  Vi är <span className="text-sky-500">bäst i Sverige</span> på att designa, bygga och arbeta med <span className="text-sky-500">moderna nätverk.</span>
                </h1>

                <div className="py-8 flex flex-col gap-6 ">
                  <h3 className="text-2xl">
                    Utmaningar med dagens krav på arkitektur?
                  </h3>
                  <h4 className="text xl">
                    Svårt att efterleva dagens krav på <span className="text-sky-500">säkerhet</span>? <br />
                    Utmaningar att leverera <span className="text-sky-500">snabbt</span> nog? <br />
                    Vilja att nå högre <span className="text-sky-500">kvalitet</span> på leverans?
                  </h4>
                  <h3 className="text-2xl">
                    Låt oss Ace:a det tillsammans!
                  </h3>
                </div>
                <div className="sm:w-1/4 w-1/2">
                  <ContactButton>
                    Kontakta oss!
                  </ContactButton>
                </div>

              </div>
            </div>
          </div>




        </div>

        {/* Videon som fyller hela skärmen */}
        <div className="flex-1 z-0">
          <Video />
        </div>
      </div>

    </div>
  )
}
